import { Component, EventEmitter, Output } from '@angular/core';
import * as fromUserPromotions from '@app/client/account/team/promotion/reducers/promotion.reducer';
import * as fromRoot from '@app/reducers';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Constant } from 'src/constant';
import { UserPromotionActions } from '../../actions';

@Component({
  selector: 'app-modal-promotion-create-add-background',
  templateUrl: './modal-promotion-create-add-background.component.html',
  styleUrls: ['./modal-promotion-create-add-background.component.scss']
})
export class ModalPromotionCreateAddBackgroundComponent {

  selectionVideo = false;
  error = false;
  url = null;

  constructor(
    private store$: Store<fromRoot.State & fromUserPromotions.State>,
    public ref: DialogRef,
  ) { }

  displaySelectionVideo() {
    this.selectionVideo = true;
  }

  hideSelectionVideo(event?: Event) {
    this.selectionVideo = false;
    this.url = null;
    if (event) {
      event.stopPropagation();
    }
  }

  addBackgroundImage(image: any) {
    const _image = [image[0]];
    this.store$.dispatch(UserPromotionActions.addImageToPromotionToCreate({ image: _image }));
    this.closeModal();
  }

  closeModal() {
    this.ref.close();
  }

  addBackgroundVideo(url) {
    let match: any;
    let video: any;
    if (url) {
      if (url.match(Constant.regexpYoutube)) {
        match = url.match(Constant.regexpYoutube);
        video = {
          url,
          sourceId: match[1], type: 'Youtube'
        };
        this.store$.dispatch(UserPromotionActions.addVideoToPromotionToCreate({ video }));
        this.closeModal();
        this.selectionVideo = false;
      } else if (url.match(Constant.regexpVimeo)) {
        match = url.match(Constant.regexpVimeo);
        video = {
          url,
          sourceId: match[1], type: 'Vimeo'
        };
        this.store$.dispatch(UserPromotionActions.addVideoToPromotionToCreate({ video }));
        this.closeModal();
        this.selectionVideo = false;
      } else {
        this.error = true;
      }
    } else {
      this.error = true;
    }
  }
}
